module.exports = __webpack_public_path__ + "static/img/ab.15be8bfb.png";